import { scopedOrders } from 'src/stash';

export default {
  computed: {
    // These next 3 methods are for the order tabs, providing both the badge count
    // on the tabs themselves, as well as a filtered subset of the full /sfu/orders
    // response for display on each tab.
    current() {
      return scopedOrders.current();
    },

    completed() {
      return scopedOrders.completed();
    },

    future() {
      return scopedOrders.future();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ScopesOrders.js